import { usePutHttp } from "../../../../hooks/http/http.hook";
import type { IPost } from "../../../../types/models/post.models.types";

interface IResponse {
  post: IPost;
}

export function useUnflagPostHttp() {
  return usePutHttp<null, IResponse>({
    path: "/brand/posts/:id/unflag",
  });
}
